import { render } from "./FAQCategories.vue?vue&type=template&id=4a0c9526&scoped=true"
import script from "./FAQCategories.vue?vue&type=script&lang=js"
export * from "./FAQCategories.vue?vue&type=script&lang=js"

import "./FAQCategories.vue?vue&type=style&index=0&id=4a0c9526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0c9526"]])

export default __exports__